import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { useSettingsContext } from "../../components/settings";
import Main from "./Main";
import Header from "./header";
import NavMini from "./nav/NavMini";
import NavVertical from "./nav/NavVertical";
import NavHorizontal from "./nav/NavHorizontal";
import { useAuthContext } from "src/auth/useAuthContext";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();
  const { user, logout } = useAuthContext();
  let dispatch = useDispatch();
  const isDesktop = useResponsive("up", "lg");
  const [open, setOpen] = useState(false);
  const isNavHorizontal = themeLayout === "horizontal";
  const isNavMini = themeLayout === "mini";
  const handleOpen = () => {
    setOpen(true);
  };
  const location = useLocation();

  const handleClose = () => {
    setOpen(false);
  };

  const [isVenueOnline, setIsVenueOnline] = useState(
    user?.venue?.isOnline ?? false
  );

  const renderNavVertical = (
    <NavVertical
      openNav={open}
      onCloseNav={handleClose}
      isVenueOnline={isVenueOnline}
    />
  );

  const isThemePage =
    /^\/dashboard\/store\/themes\/Preview\/[^\/]+$/.test(
      location.pathname
    ) ||
    /^\/dashboard\/store\/themes\/[^\/]+\/edit$/.test(location.pathname);

  if (isThemePage) {
    return <Outlet />;
  }

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: "flex" },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? (
            <NavMini isVenueOnline={isVenueOnline} />
          ) : (
            renderNavVertical
          )}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: "flex" },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
